import AssistantAvatar from './AssistantAvatar.vue';

export default AssistantAvatar;
